export interface ApiConfig {
  baseUrl: string;
  timeout: number;
  headers: Record<string, string>;
}

export interface AppConfig {
  name: string;
  version: string;
  environment: 'development' | 'staging' | 'production';
}

export const getApiConfig = (): ApiConfig => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';
  
  return {
    baseUrl,
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '50000'),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  };
};

export const getAppConfig = (): AppConfig => {
  return {
    name: import.meta.env.VITE_APP_NAME || 'Surgia',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: (import.meta.env.MODE as AppConfig['environment']) || 'development',
  };
};

export const config = {
  api: getApiConfig(),
  app: getAppConfig(),
};

export default config; 